import camelcaseKeys from 'camelcase-keys'

import Config from 'config/config'

interface RestOptions {
    camelCaseKeys: boolean
}

const defaultRestOptions: RestOptions = {
    camelCaseKeys: true
}

export const get = async <T = any>(url: string, options: RestOptions = defaultRestOptions): Promise<T> => {
    const request: RequestInit = {
        method: "GET"
    }
    return execute(url, request, options)
}

export const post = async <T = any>(url: string, options: RestOptions = defaultRestOptions, data?: any): Promise<T> => {
    const request: RequestInit = {
        method: "POST",
        body: JSON.stringify(camelcaseKeys(data, { deep: true, pascalCase: true}))
    }
    return execute(url, request, options)
}

const execute = async (url: string, request: RequestInit, options: RestOptions): Promise<any> => {
    const apiUrl = `${Config.API_BASE}${url}`
    const response = await fetch(apiUrl, request)
    return await processResponse(response, options)
}

const processResponse = async (response: Response, options: RestOptions): Promise<any> => {
    if (response.ok) {
        if (response.status === 204) {
            return
        }
    } else {
        if (response.status === 422) {
            const errorJson: any = camelcaseKeys(await response.json(), { deep: true }) 
            console.log("Error JSON payload:", errorJson)
            throw Error(`(${response.status}): ${errorJson.message}`)
        } else {
            throw Error(`(${response.status}): ${response.statusText}`)
        }
    }

    return options.camelCaseKeys ? camelcaseKeys(await response.json(), {deep: true}) : response.json()
}

export default {
    get,
    post,
    // put,
    // patch,
    // delete: deleteOp
}
